import { createApp } from 'vue'
import { AppSettingsKey } from './types/keys'
import { getAppSettings } from './services/app-settings-service'
import App from './App.vue'

const app = createApp(App)
const settings = getAppSettings()

app.provide(AppSettingsKey, settings)
app.mount('#travelUpdates')
